module.exports = __webpack_public_path__ + "media/assets/images/flags/ba-c0f84a61c8ebbe91803c754b49b68214.svg";